export const messages = {
  header: {
    section: {
      id: 'admin/promotions.form.change-benefit.modal.header.section',
    },
    config: {
      id: 'admin/promotions.form.change-benefit.modal.header.config',
    },
  },
}
